import {
  PublicEntityTemplate,
  TemplatableEntity,
} from '@payaca/types/entity-templates';
import { WithOptional } from '@payaca/utilities/types';

/**
 * Blank templates for opening CreateEditEntityTemplateModal in create mode.
 *
 * These are module-level constants on purpose. ValidatedForm resets its form
 * state whenever its initialFormState prop changes identity, and the modal's
 * create controls derive initialFormState from this template.
 */
export const BLANK_ENTITY_TEMPLATES: {
  [EntityType in TemplatableEntity]: WithOptional<
    PublicEntityTemplate<EntityType>,
    'publicId'
  >;
} = {
  task: { entityType: 'task', data: {} },
  scheduledEvent: { entityType: 'scheduledEvent', data: {} },
  proposal: { entityType: 'proposal', data: {} },
};
